<template>
  <div class="iconWrapper">
    <i class="icon bi bi-arrow-repeat" />
  </div>
  <div class="title">{{ $t("game.preGameModalChecksChecking.title") }}</div>
  <div class="text">{{ $t("game.preGameModalChecksChecking.text") }}</div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.iconWrapper {
  width: 64px;
  height: 64px;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  font-size: 36px;

  background-color: #1fa969;

  .icon {
    animation: spinner 1.5s linear infinite;

    @keyframes spinner {
      to {
        transform: rotate(360deg);
      }
    }
  }
}

.title {
  font-size: 32px;
  font-weight: 700;
  text-align: center;
}

.text {
  font-size: 18px;
  text-align: center;
}

@media screen and (max-width: $small-screen) {
  .title {
    font-size: 20px;
  }

  .text {
    font-size: 14px;
  }
}
</style>
